import { DashedFocusBorder } from 'components/Common/DashedFocusBorder';
import styled from 'styled-components';

export const CSSMailItemWrapper = styled.div<{ read: boolean }>`
    position: relative;
    border-bottom: ${(props) => props.theme.color.grey2};
    border-bottom-style: solid;
    border-bottom-width: 1px;
    background-color: ${(props) => (props.read ? props.theme.color.grey0 : props.theme.color.white)};
    padding: ${(props) => props.theme.space.md}px;
    &:hover {
        background-color: ${(props) => props.theme.color.grey2};
    }
`;

export const CSSMailItemHref = styled.a`
    position: absolute;
    inset: 0;
    cursor: pointer;
    transition: background-color 0.2s;
    ${DashedFocusBorder()}
`;

export const CSSMailItemHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${(props) => props.theme.space.sm}px;
    margin-bottom: ${(props) => props.theme.space.sm}px;
`;

export const CSSMailItemHeaderFrom = styled.div`
    flex: 1;
    display: flex;
`;

export const CSSMailItemFooter = styled.div`
    margin-top: ${(props) => props.theme.space.sm}px;
`;

export const CSSMailItemSubject = styled.h3`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
`;

export const CSSMailItemBody = styled.div<{ maxHeight: number }>`
    max-height: ${(props) => props.maxHeight}px;
    overflow: hidden;
`;
